
import floatingScrollBehavior from '@/mixins/floatingScrollBehavior'

export default {
  name: 'CartFloatEntry',
  // 滚动 PEEK 状态机与首页货篮钮/智能助手 FAB 共用（全站兄弟控件同一行为）
  mixins: [floatingScrollBehavior],
  floatBtnRef: 'cartBtn',
  data () {
    return {
      isDragging: false,
      hasMoved: false,
      dragStartX: 0,
      dragStartY: 0,
      btnX: 0,
      btnY: 0
    }
  },
  computed: {
    cartCount () {
      return this.$store.state.cartCount || 0
    },
    visible () {
      const p = this.$route.path
      return this.$store.getters.isUser
        && this.cartCount > 0
        && !p.startsWith('/admin') && !p.startsWith('/courier') && p !== '/home'
    }
  },
  mounted () {
    this.fetchCartCount()
    // 可见才挂滚动监听（隐藏时零监听；/home 用页内货篮钮，此钮排除）
    if (this.visible) this.bindFloatScroll()
  },
  watch: {
    $route () {
      this.fetchCartCount()
    },
    visible (v) {
      v ? this.bindFloatScroll() : this.unbindFloatScroll()
    }
  },
  methods: {
    fetchCartCount () {
      this.$store.dispatch('refreshCartCount')
    },
    onCartClick () {
      this.resetFloatPeek() // 点击即复原（共享状态机约定）
      if (this.hasMoved) return
      this.$router.push('/cart')
    },
    startDrag (e) {
      // 仅 mouse preventDefault（touchstart 上 preventDefault 会吞合成 click；助手 FAB 同款）
      if (e.type === 'mousedown' && e.preventDefault) e.preventDefault()
      this.isDragging = true
      this.hasMoved = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartX = touch.clientX
      this.dragStartY = touch.clientY
      const btn = this.$refs.cartBtn
      if (!btn) return
      const rect = btn.getBoundingClientRect()
      this.btnX = rect.left
      this.btnY = rect.top
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
      document.addEventListener('touchmove', this.onDrag)
      document.addEventListener('touchend', this.endDrag)
    },
    onDrag (e) {
      if (!this.isDragging) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartX
      const dy = touch.clientY - this.dragStartY
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) this.hasMoved = true
      const btn = this.$refs.cartBtn
      if (!btn) return
      btn.style.left = (this.btnX + dx) + 'px'
      btn.style.top = (this.btnY + dy) + 'px'
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
    },
    endDrag () {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.endDrag)
      const btn = this.$refs.cartBtn
      if (!btn) return
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const winH = window.innerHeight
      const margin = 20
      const btnW = 50
      const btnH = 50
      btn.style.transition = 'all 0.3s ease'
      if (rect.left < winW / 2) {
        btn.style.left = margin + 'px'
      } else {
        btn.style.left = (winW - margin - btnW) + 'px'
      }
      const top = Math.max(margin, Math.min(winH - margin - btnH, rect.top))
      btn.style.top = top + 'px'
      setTimeout(() => { btn.style.transition = '' }, 300)
    }
  }
}
